import axios from 'axios';

// Keep bearer credentials in the request header; only a temporary blob URL is opened.
export async function openPrivateDocument(value, browser = window) {
  const base = new URL(axios.defaults.baseURL, browser.location.origin);
  const target = new URL(value, base);
  if (target.origin !== base.origin || target.username || target.password || target.search || target.hash
      || !target.pathname.startsWith(base.pathname.replace(/\/$/, '') + '/uploads/')) {
    throw new Error('Alamat dokumen tidak valid');
  }
  const token = browser.localStorage.getItem('token');
  if (!token) throw new Error('Silakan masuk untuk membuka dokumen');
  const popup = browser.open('about:blank', '_blank');
  if (popup) popup.opener = null;
  let blobUrl;
  try {
    const response = await axios.get(target.href, {
      responseType: 'blob', headers: { Authorization: `Bearer ${token}` },
    });
    blobUrl = browser.URL.createObjectURL(response.data);
    if (popup) popup.location.replace(blobUrl);
    else {
      const link = browser.document.createElement('a');
      link.href = blobUrl;
      link.download = target.pathname.split('/').pop() || 'dokumen';
      browser.document.body.appendChild(link); link.click(); link.remove();
    }
    // Opening a PDF can take time; revoke after the viewer has consumed the URL.
    browser.setTimeout(() => browser.URL.revokeObjectURL(blobUrl), 120000);
  } catch (error) {
    if (popup) popup.close();
    if (blobUrl) browser.URL.revokeObjectURL(blobUrl);
    let message = error.message || 'Dokumen belum dapat dibuka';
    if (error.response?.data?.text) {
      try { message = JSON.parse(await error.response.data.text()).message || message; } catch { /* Keep the fallback message. */ }
    }
    throw new Error(message);
  }
}

export default {
  bind(element, binding, vnode) {
    element.__privateDocumentValue = binding.value;
    element.__privateDocumentHandler = async (event) => {
      event.preventDefault();
      if (element.__privateDocumentLoading) return;
      element.__privateDocumentLoading = true;
      element.setAttribute('aria-busy', 'true');
      try { await openPrivateDocument(element.__privateDocumentValue); }
      catch (error) {
        const dialog = vnode.context?.$swal;
        if (dialog) dialog.fire({ title: 'Dokumen belum dapat dibuka', text: error.message, icon: 'error' });
      } finally {
        element.__privateDocumentLoading = false;
        element.removeAttribute('aria-busy');
      }
    };
    element.addEventListener('click', element.__privateDocumentHandler);
  },
  update(element, binding) { element.__privateDocumentValue = binding.value; },
  unbind(element) {
    element.removeEventListener('click', element.__privateDocumentHandler);
    delete element.__privateDocumentValue;
    delete element.__privateDocumentHandler;
  },
};
